<template>
    <div class="previewBox">
        <el-table
                style="width: 100%">
            <el-table-column
                    v-for="item in tableData" :key="item.key"
                    :label="item.label">
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import { previewTemplate } from '../../api/templatePage';

    export default {
        name: 'preview',
        data() {
            return {
                tableData: []
            };
        },
        created() {
            previewTemplate({ id: this.$route.query.id }).then(res => {
                if (res.code == 200) {
                    this.tableData = res.data.all_arr;
                } else {
                    this.$message.error(res.msg);
                }
            });
        }
    };
</script>

<style scoped>
    .previewBox {
        background-color: #ffffff;
        padding: 30px;
        border-radius: 5px;
    }
</style>
